/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Destination_UnavailableInputs */



/**
* | output |
* | --- |
* | "Current destination (not available to you)" |
*
* @param {Agent_Builder_Destination_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_destination_unavailable = /** @type {((inputs?: Agent_Builder_Destination_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Destination_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelles Ziel (für Sie nicht verfügbar)")
	return /** @type {LocalizedString} */ ("Current destination (not available to you)")
});